import React, { useEffect, useState } from 'react';
import client from '../api/client';
import { useAuth } from '../context/AuthContext';

const empty = { code: '', name_ar: '', name_en: '', category: 'rifle', gender: 'male', qualification_shots: '', qualification_max: '', finalists_count: 8, sort_order: 0 };
const categoryLabels = { rifle: 'بندقية', pistol: 'مسدس', shotgun: 'رماية تراب/سكيت' };

export default function Disciplines() {
  const { user } = useAuth();
  const isAdmin = user.role === 'admin';
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState(null);

  const load = () => client.get('/disciplines').then(r => setRows(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      if (editingId) await client.put(`/disciplines/${editingId}`, form);
      else await client.post('/disciplines', form);
      setForm(empty); setEditingId(null);
      load();
    } catch (err) { setError(err.response?.data?.message || 'خطأ'); }
  };

  const edit = (d) => {
    setForm({ code: d.code, name_ar: d.name_ar, name_en: d.name_en || '', category: d.category, gender: d.gender, qualification_shots: d.qualification_shots || '', qualification_max: d.qualification_max || '', finalists_count: d.finalists_count, sort_order: d.sort_order });
    setEditingId(d.id);
  };

  const remove = async (id) => {
    if (!window.confirm('تأكيد الحذف؟ سيتم حذف كل النتائج المرتبطة بهذه المسابقة.')) return;
    try { await client.delete(`/disciplines/${id}`); load(); }
    catch (err) { alert(err.response?.data?.message || 'خطأ'); }
  };

  return (
    <div className="grid grid-2">
      <div className="card">
        <h3 style={{ marginTop: 0 }}>{editingId ? 'تعديل مسابقة' : 'إضافة مسابقة رماية'}</h3>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={submit}>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>الرمز (Code) *</label>
            <input value={form.code} onChange={e => setForm({ ...form, code: e.target.value })} required />
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>الاسم (عربي) *</label>
            <input value={form.name_ar} onChange={e => setForm({ ...form, name_ar: e.target.value })} required />
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>الاسم (English)</label>
            <input value={form.name_en} onChange={e => setForm({ ...form, name_en: e.target.value })} />
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>النوع</label>
            <select value={form.category} onChange={e => setForm({ ...form, category: e.target.value })}>
              <option value="rifle">بندقية</option><option value="pistol">مسدس</option><option value="shotgun">رماية تراب/سكيت</option>
            </select>
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>الجنس</label>
            <select value={form.gender} onChange={e => setForm({ ...form, gender: e.target.value })}>
              <option value="male">رجال</option><option value="female">سيدات</option>
            </select>
          </div>
          <div className="form-field" style={{ marginBottom: 10 }}>
            <label>الحد الأقصى للنتيجة</label>
            <input type="number" step="0.1" value={form.qualification_max} onChange={e => setForm({ ...form, qualification_max: e.target.value })} />
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-primary">{editingId ? 'حفظ التعديلات' : 'إضافة'}</button>
            {editingId && <button type="button" className="btn btn-outline" onClick={() => { setEditingId(null); setForm(empty); }}>إلغاء</button>}
          </div>
        </form>
      </div>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>المسابقات ({rows.length})</h3>
        <table>
          <thead><tr><th>الاسم</th><th>النوع</th><th></th></tr></thead>
          <tbody>
            {rows.map(d => (
              <tr key={d.id}>
                <td>{d.name_ar}</td>
                <td>{categoryLabels[d.category]} · {d.gender === 'male' ? 'رجال' : 'سيدات'}</td>
                <td style={{ display: 'flex', gap: 6 }}>
                  <button className="btn btn-outline" onClick={() => edit(d)}>تعديل</button>
                  {isAdmin && <button className="btn btn-danger" onClick={() => remove(d.id)}>حذف</button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
